import { render, staticRenderFns } from "./Objeto.vue?vue&type=template&id=31d33205&scoped=true"
import script from "./Objeto.vue?vue&type=script&lang=js"
export * from "./Objeto.vue?vue&type=script&lang=js"
import style0 from "./Objeto.vue?vue&type=style&index=0&id=31d33205&prod&lang=scss&scoped=true"
import style1 from "./Objeto.vue?vue&type=style&index=1&id=31d33205&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d33205",
  null
  
)

export default component.exports